import { InputNumberLocalized } from '@components'

import type { ReactElement } from 'react'

import { useFormContext, useWatch } from '../../../../../../../../../../../hooks'
import type { ReviewEntryDataFormSchema } from '../../../../../../../../../types/getReviewEntryDataFormSchema'
import * as Styled from '../../../styles'

type ReviewEntryLineItemAmountFieldName = `entryLines.${number}.vatAmount`

interface ReviewEntryLineItemReadOnlyAmountFieldProps {
  isDisabled?: boolean
  label: string
  name: ReviewEntryLineItemAmountFieldName
}

export const ReviewEntryLineItemReadOnlyAmountField = ({
  isDisabled = false,
  label,
  name,
}: ReviewEntryLineItemReadOnlyAmountFieldProps): ReactElement => {
  const { control } = useFormContext<ReviewEntryDataFormSchema>()
  const value = useWatch({ control, name })

  return (
    <Styled.ReviewEntryLineItemCellField>
      <InputNumberLocalized
        alignment="right"
        aria-label={label}
        disabled={isDisabled}
        isFallbackToZero={false}
        key={value ?? 'empty'}
        name={name}
        readOnly
        size="sm"
        value={value}
      />
    </Styled.ReviewEntryLineItemCellField>
  )
}
